import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import axios from "axios";

import { resetTokenAndClearUser } from './utils'
import {getQuery} from './utils/resqCode'
//import { LoadingBar } from 'iview'
import request from "./utils/request";

let code = getQuery('code')
let state = getQuery('state')
if(code && state !== 'wechat_web'){
    let data = {
        code:code
    }
    request.post('/muser/other/'+state+'/do/sign-in',data).then(suc=>{
        if(suc.code == 0 && suc.status == 200){
            if(suc.data.isBindWx){
                alert('授权成功！请关闭此网页！');
            }else{
                alert('授权失败！请关闭此网页重新授权！');
            }
        }else{
            alert('授权失败！请关闭此网页重新授权！');
        }
    },err=>{
        alert('授权失败！请关闭此网页重新授权！');
    })
}else if(!code && !state){
//import "./permission";


let hasMenus = false
router.beforeEach(async (to, from, next) => {
    //LoadingBar.start()
    /*let code = getQuery('code')
    let state = getQuery('state')
    if(code && state !== 'wechat_web'){
            let data = {
                code:code
            }
            request.post('/muser/other/'+state+'/do/sign-in',data).then(suc=>{
                if(suc.code == 0 && suc.status == 200){
                    if(suc.data.isBindWx){
                        alert('授权成功！请关闭此网页！');
                    }else{
                        alert('授权失败！请关闭此网页重新授权！');
                    }
                }else{
                    alert('授权失败！请关闭此网页重新授权！');
                }
            },err=>{
                alert('授权失败！请关闭此网页重新授权！');
            })
        next({path:'/'})
    }else if(code && state == 'wechat_web'){
        next() //this.$route.params.code
    }else{  */
        if (localStorage.getItem('token')) {
            if (to.path === '/login') {
                next({path: '/'})
            } else {
                if (hasMenus) {
                    next()
                } else {
                    try {
                        // 这里可以用 await 配合请求后台数据来生成路由
                        // const data = await axios.get('xxx')
                        // const routes = menusToRoutes(data)
                        //const routes = menusToRoutes(store.state.menuItems)
                        // 动态添加路由
                        //router.addRoutes(routes)
                        hasMenus = true
                        next({path: to.path || '/'})
                    } catch (error) {
                        resetTokenAndClearUser()
                        next(`/login`)
                    }
                }
            }
        } else {
            hasMenus = false
            if (to.path === '/login') {
                next()
            } else {
                next(`/login`)
            }
        }
    /*}*/
})

/*router.afterEach(() => {
    LoadingBar.finish()
})*/
}

import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

//elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

Vue.config.devtools = true

//引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import vueCanvasPoster from "vue-canvas-poster";
Vue.use(vueCanvasPoster);

import Qs from "qs"; //引入方式
Vue.prototype.$qs = Qs; //全局加载

Vue.config.productionTip = false;

// 设置基础URL
axios.defaults.baseURL = process.env.BASE_URL;
// 设置请求超时时间
axios.defaults.timeout = 10000;

Vue.prototype.$axios = axios;
Vue.prototype.$request = request;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js